import { useState, useEffect } from 'react';
import { format } from 'date-fns';

export const StatusBar = () => {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <footer className="border-t border-gray-200 bg-white h-10 flex items-center px-4 text-xs text-gray-500 shrink-0">
      <div className="flex items-center gap-2">
        <span className="size-2 rounded-full bg-green-500" />
        연결됨
      </div>
      <div className="ml-auto">
        {format(now, 'yyyy-MM-dd HH:mm:ss')}
      </div>
    </footer>
  );
};
